import { StateCreator } from "zustand";

import type { BreakpointKey, DashboardSliceType } from "@/state/@types";

/**
 * What the browser remembers about a report page.
 *
 * Only which tab of a report was open and how wide the page is being read at.
 * The layouts themselves belong to the report, on the server; the named
 * "profiles" that used to be kept here were a second set of defaults nothing
 * ever wrote to, and a new report was seeded from them.
 */
export const createDashboardSlice: StateCreator<
  DashboardSliceType,
  [],
  [],
  DashboardSliceType
> = (set, get) => ({
  currentDashboardBreakpoint: "md" as BreakpointKey,
  activeReportTabIds: {},

  setCurrentDashboardBreakpoint: (breakpoint) => {
    if (get().currentDashboardBreakpoint !== breakpoint) {
      set({ currentDashboardBreakpoint: breakpoint });
    }
  },

  setActiveReportTabId: (layoutIdentifier, tabId) => {
    set({
      activeReportTabIds: {
        ...get().activeReportTabIds,
        [layoutIdentifier]: tabId,
      },
    });
  },
});
